<template>
  <v-card>
    <v-card-title primary-title>
      Ta bort användare
    </v-card-title>

    <v-card-text>
      <p>
        Är du säker på att du vill ta bort användare:
      </p>
      <strong>
        {{ user.first_name }} {{ user.last_name }}, {{ user.email }}
      </strong>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn tile text @click="close" :disabled="pendingDelete">
        Avbryt
      </v-btn>
      <v-btn
        tile
        color="error"
        text
        @click="deleteUser"
        :loading="pendingDelete"
      >
        Ta bort
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'UserDelete',

  props: {
    user: Object
  },

  data: () => ({
    pendingDelete: false
  }),

  methods: {
    close() {
      this.$emit('close')
    },

    async deleteUser() {
      this.pendingDelete = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation deleteUser($id: Int!) {
            deleteUser(id: $id)
          }
        `,

        variables: {
          id: parseInt(this.user.id, 10)
        }
      })

      this.pendingDelete = false
      this.$emit('confirm')
    }
  }
}
</script>
